// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dynamic_component_wrapper__05fSq"};